enum SkuEnum {
  'consider_these_similar_products' = 'consider_these_similar_products',
  'details.details' = 'details.details',
  'details.features' = 'details.features',
  'details.subCategory' = 'details.subCategory',
  'details.brand' = 'details.brand',
  'details.countrySlashRegion' = 'details.countrySlashRegion',
  'details.country' = 'details.country',
  'details.region' = 'details.region',
  'details.size' = 'details.size',
  'details.release_year' = 'details.release_year',
  'details.distilled_year' = 'details.distilled_year',
  'details.number_of_bottles' = 'details.number_of_bottles',
  'details.description' = 'details.description',
  'details.VolumeInPercent' = 'details.VolumeInPercent',
  'value.value' = 'value.value',
  'value.line_chart' = 'value.line_chart',
  'value.metrics' = 'value.metrics',
  'value.number_of_sales' = 'value.number_of_sales',
  'value.market_value' = 'value.market_value',
  'value.avg_sale_price' = 'value.avg_sale_price',
  'value.retail_price' = 'value.retail_price',
  'value.total_return' = 'value.total_return',
  'value.sales' = 'value.sales',
  'value.date' = 'value.date',
  'value.sale_result' = 'value.sale_result',
  'last_activity.last_activity' = 'last_activity.last_activity',
  'last_activity.no_activity_data' = 'last_activity.no_activity_data',
  'last_activity.all' = 'last_activity.all',
  'last_activity.order' = 'last_activity.order',
  'last_activity.ask' = 'last_activity.ask',
  'last_activity.bid' = 'last_activity.bid',
  'last_activity.1w' = 'last_activity.1w',
  'last_activity.1m' = 'last_activity.1m',
  'last_activity.1y' = 'last_activity.1y',
  'last_activity.6m' = 'last_activity.6m',
  'last_activity.max' = 'last_activity.max',
  'last_activity.no_activity_for_the_selected_filters' = 'last_activity.no_activity_for_the_selected_filters',
  'last_activity.item' = 'last_activity.item',
  'last_activity.time' = 'last_activity.time',
  'last_activity.trend' = 'last_activity.trend',
  'last_activity.price' = 'last_activity.price',
  'last_activity.action' = 'last_activity.action',
  'last_activity.image' = 'last_activity.image',
  'last_activity.show_less' = 'last_activity.show_less',
  'last_activity.show_more' = 'last_activity.show_more',
  'last_activity.last_activities' = 'last_activity.last_activities',
  'navBar.add_to_wishlist' = 'navBar.add_to_wishlist',
  'navBar.remove_from_wishlist' = 'navBar.remove_from_wishlist',
  'navBar.add_to_your_portfolio' = 'navBar.add_to_your_portfolio',
  'navBar.add_to_portfolio' = 'navBar.add_to_portfolio',
  'navBar.share' = 'navBar.share',
  'navBar.price_you_paid' = 'navBar.price_you_paid',
  'navBar.amount' = 'navBar.amount',
  'navBar.purchase_date' = 'navBar.purchase_date',
  'navBar.type_price' = 'navBar.type_price',
  'product.suggest_your_price_bid' = 'product.suggest_your_price_bid',
  'product.buy_for' = 'product.buy_for',
  'product.sell_for' = 'product.sell_for',
  'product.or_ask_for_more' = 'product.or_ask_for_more',
  'product.sell_this_bottle' = 'product.sell_this_bottle',
  'product.view_asks' = 'product.view_asks',
  'product.no_asks' = 'product.no_asks',
  'product.view_bids' = 'product.view_bids',
  'product.no_bids' = 'product.no_bids',
  'product.view_orders' = 'product.view_orders',
  'product.no_orders' = 'product.no_orders',
  'product.last_sale_price' = 'product.last_sale_price',
  'product.spiritory_buyer_protection' = 'product.spiritory_buyer_protection',
  'product.buyer_protection_desc' = 'product.buyer_protection_desc',
  'product.authenticated_by_spiritory' = 'product.authenticated_by_spiritory',
  'product.authenticated_desc' = 'product.authenticated_desc',
  'product.learn_more' = 'product.learn_more',
  'product.bottle_condition_and_packaging' = 'product.bottle_condition_and_packaging',
  'product.bottle_condition_desc' = 'product.bottle_condition_desc',
  'product.bottle_condition_page' = 'product.bottle_condition_page',
  'modal.value' = 'modal.value',
  'modal.date' = 'modal.date',
  'modal.time' = 'modal.time',
  'buy.highest_bid' = 'buy.highest_bid',
  'buy.lowest_ask' = 'buy.lowest_ask',
  'buy.congratulations' = 'buy.congratulations',
  'buy.your_purchase_has_been_placed_for' = 'buy.your_purchase_has_been_placed_for',
  'buy.your_bottle_is_now_saved_for_you' = 'buy.your_bottle_is_now_saved_for_you',
  'buy.spiritory_bottle_buy_subtitle' = 'buy.spiritory_bottle_buy_subtitle',
  'buy.go_to_payment' = 'buy.go_to_payment',
  'buy.the_spiritory_team_will_verify_the_item_within_48_hours' = 'buy.the_spiritory_team_will_verify_the_item_within_48_hours',
  'buy.you_will_receive_a_tracking_num' = 'buy.you_will_receive_a_tracking_num',
  'buy.done' = 'buy.done',
  'buy.your_bid_for' = 'buy.your_bid_for',
  'buy.is_live' = 'buy.is_live',
  'buy.when_your_bid_is_accepted' = 'buy.when_your_bid_is_accepted',
  'buy.anytime_before_its_accepted' = 'buy.anytime_before_its_accepted',
  'buy.back_to_product' = 'buy.back_to_product',
  'buy.buy_now' = 'buy.buy_now',
  'buy.place_bid' = 'buy.place_bid',
  'buy.you_re_about_to_buy_product_low_ask' = 'buy.you_re_about_to_buy_product_low_ask',
  'buy.proccesing_fee' = 'buy.proccesing_fee',
  'buy.shipping' = 'buy.shipping',
  'buy.shipping_text' = 'buy.shipping_text',
  'buy.included' = 'buy.included',
  'buy.total' = 'buy.total',
  'buy.cancel' = 'buy.cancel',
  'buy.place_order' = 'buy.place_order',
  'buy.18_years_old' = 'buy.18_years_old',
  'buy.write_down_bid' = 'buy.write_down_bid',
  'buy.duration' = 'buy.duration',
  'buy.7_days' = 'buy.7_days',
  'buy.14_days' = 'buy.14_days',
  'buy.30_days' = 'buy.30_days',
  'buy.60_days' = 'buy.60_days',
  'tasting_notes.title' = 'tasting_notes.title',
  'tasting_notes.subtitle' = 'tasting_notes.subtitle',
  'buy.item' = 'buy.item',
  'buy.enter_date' = 'buy.enter_date',
  'buy.your_price' = 'buy.your_price',
  'buy.quantity' = 'buy.quantity',
  'buy.choose_duration' = 'buy.choose_duration',
  'sell.highest_bid' = 'sell.highest_bid',
  'sell.18_years_old' = 'sell.18_years_old',
  'sell.lowest_ask' = 'sell.lowest_ask',
  'sell.your_ask_for' = 'sell.your_ask_for',
  'sell.your_sale_for' = 'sell.your_sale_for',
  'sell.is_confirmed' = 'sell.is_confirmed',
  'sell.is_live' = 'sell.is_live',
  'sell.when_a_buyer_accept_your_ask' = 'sell.when_a_buyer_accept_your_ask',
  'sell.adjust_ask' = 'sell.adjust_ask',
  'sell.sell_now' = 'sell.sell_now',
  'sell.place_ask' = 'sell.place_ask',
  'sell.you_are_going_to_buy_this_product_highest' = 'sell.you_are_going_to_buy_this_product_highest',
  'sell.you_are_going_to_sell_this_product_lowest' = 'sell.you_are_going_to_sell_this_product_lowest',
  'sell.comission_fee' = 'sell.comission_fee',
  'sell.shipping_text' = 'sell.shipping_text',
  'sell.will_be_calculated_later' = 'sell.will_be_calculated_later',
  'sell.payment_processing' = 'sell.payment_processing',
  'sell.confirm_sale' = 'sell.confirm_sale',
  'sell.please_write_down_the_price_you_re_willing_to_sell' = 'sell.please_write_down_the_price_you_re_willing_to_sell',
  'sell.bottle_new' = 'sell.bottle_new',
  'billing_slash_shipping' = 'billing_slash_shipping',
  'buy_advice' = 'buy_advice',
  'buy_now' = 'buy_now',
  'bid' = 'bid',
  'make_an_offer' = 'make_an_offer',
  'buy_it_cheaper_if_seller_accepts_your_price' = 'buy_it_cheaper_if_seller_accepts_your_price',
  'finish' = 'finish',
  'review_bid' = 'review_bid',
  'place_bid' = 'place_bid',
  'suggest_your_price' = 'suggest_your_price',
  'review_order' = 'review_order',
  'place_order' = 'place_order',
  'valid_until' = 'valid_until',
  'apply' = 'apply',
  'sell_word' = 'sell_word',
  'seller_advice' = 'seller_advice',
  'ask_your_price' = 'ask_your_price',
  'sell_it_a_better_price_if_buyer_accepts_your_price' = 'sell_it_a_better_price_if_buyer_accepts_your_price',
  'in_order_to_complete_transaction' = 'in_order_to_complete_transaction',
  'you_will_receive' = 'you_will_receive',
  'review_ask' = 'review_ask',
  'place_ask' = 'place_ask',
  'ask' = 'ask',
  'no_buyer_has_left_a_bid_yet' = 'no_buyer_has_left_a_bid_yet',
  'review_sale' = 'review_sale',
  'confirm_sale' = 'confirm_sale',
  'your_current_ask_for_this_item_is' = 'your_current_ask_for_this_item_is',
  'your_current_bid_for_this_item_is' = 'your_current_bid_for_this_item_is',
  'item_activity' = 'item_activity',
  'activity_type' = 'activity_type',
  'all' = 'all',
  'no_activity' = 'no_activity',
  'order' = 'order',
  'asks' = 'asks',
  'bids' = 'bids',
  'orders' = 'orders',
  '1w' = '1w',
  '1m' = '1m',
  'view_market_data' = 'view_market_data',
  'ask_price' = 'ask_price',
  'date' = 'date',
  'no_asks_available' = 'no_asks_available',
  'bid_price' = 'bid_price',
  'no_bids_available' = 'no_bids_available',
  'order_price' = 'order_price',
  'no_orders_available' = 'no_orders_available',
  'fulfill.bid' = 'fulfill.bid',
  'fulfill.ask' = 'fulfill.ask',
  'fulfill.please_fill_in_the_information_to_be_able_to_buy' = 'fulfill.please_fill_in_the_information_to_be_able_to_buy',
  'fulfill.please_fill_in_the_information_to_be_able_to_sell' = 'fulfill.please_fill_in_the_information_to_be_able_to_sell',
  'fulfill.you_have_filled_in_the_information' = 'fulfill.you_have_filled_in_the_information',
  'fulfill.you_will_be_redirected_to_the_sell_page_in_a_few_seconds' = 'fulfill.you_will_be_redirected_to_the_sell_page_in_a_few_seconds',
  'fulfill.you_will_be_redirected_to_the_buy_page_in_a_few_seconds' = 'fulfill.you_will_be_redirected_to_the_buy_page_in_a_few_seconds',
  'fulfill.click_here_if_you_are_not_redirected' = 'fulfill.click_here_if_you_are_not_redirected',
  'fulfill.loading_data_subtitle' = 'fulfill.loading_data_subtitle',
  'with_original_box' = 'with_original_box',
  'year_of_production' = 'year_of_production',
  'buy_now_for' = 'buy_now_for',
  'shipping_included_in_price' = 'shipping_included_in_price',
  'in_store_available' = 'in_store_available',
  'in_store_available_hint' = 'in_store_available_hint',
  'in_store_price' = 'in_store_price',
  'last_sale' = 'last_sale',
  'sell_now_for_x_or_ask_for_more' = 'sell_now_for_x_or_ask_for_more',
  'description' = 'description',
  'price_history' = 'price_history',
  '12_month_historical' = '12_month_historical',
  'do_you_have_any_questions' = 'do_you_have_any_questions',
  'contact_us' = 'contact_us',
  'condition' = 'condition',
  'NEW' = 'NEW',
  'product_details' = 'product_details',
  'no_description_yet' = 'no_description_yet',
  'market_data' = 'market_data',
  'professional_seller' = 'professional_seller',
  'be_the_first_to_submit_an_ask' = 'be_the_first_to_submit_an_ask',
  'like_new_ampersand_unopened' = 'like_new_ampersand_unopened',
  'sold_out' = 'sold_out',
  'tasting_ticket_no_refund' = 'tasting_ticket_no_refund',
  'no_sales_yet' = 'no_sales_yet',
  'faqs.faq1_q' = 'faqs.faq1_q',
  'faqs.faq1_a' = 'faqs.faq1_a',
  'faqs.faq2_q' = 'faqs.faq2_q',
  'faqs.faq2_a' = 'faqs.faq2_a',
  'faqs.faq3_q' = 'faqs.faq3_q',
  'faqs.faq3_a' = 'faqs.faq3_a',
  'faqs.faq4_q' = 'faqs.faq4_q',
  'faqs.faq4_a' = 'faqs.faq4_a',
  'faqs.faq5_q' = 'faqs.faq5_q',
  'faqs.faq5_a' = 'faqs.faq5_a',
  'faqs.faq6_q' = 'faqs.faq6_q',
  'faqs.faq6_a' = 'faqs.faq6_a',
  'meta_desc_1' = 'meta_desc_1',
  'meta_desc_2' = 'meta_desc_2',
  'meta_desc_3' = 'meta_desc_3',
  'for_sellers' = 'for_sellers',
  'all_asks' = 'all_asks',
  'all_bids' = 'all_bids',
  'all_orders' = 'all_orders',
  'ask_value' = 'ask_value',
  'bid_value' = 'bid_value',
  'order_value' = 'order_value',
  'line_chart_of_cost_of_the_bottle' = 'line_chart_of_cost_of_the_bottle',
  'meta_desc_4' = 'meta_desc_4',
  'expert_reviews' = 'expert_reviews',
  'export_rating' = 'export_rating',
  'expert_reviews_desc' = 'expert_reviews_desc',
  'review_for_product' = 'review_for_product',
  'tasting.eyebrow' = 'tasting.eyebrow',
  'tasting.event_details' = 'tasting.event_details',
  'tasting.hosted_by' = 'tasting.hosted_by',
  'tasting.date' = 'tasting.date',
  'tasting.time' = 'tasting.time',
  'tasting.duration' = 'tasting.duration',
  'tasting.location' = 'tasting.location',
  'tasting.format' = 'tasting.format',
  'tasting.format_in_person' = 'tasting.format_in_person',
  'tasting.parking' = 'tasting.parking',
  'tasting.parking_available' = 'tasting.parking_available',
  'tasting.spots_available' = 'tasting.spots_available',
  'tasting.ticket_price' = 'tasting.ticket_price',
  'tasting.spots_remaining' = 'tasting.spots_remaining',
  'tasting.spots_and_price' = 'tasting.spots_and_price',
  'tasting.event_over' = 'tasting.event_over',
  'tasting.event_over_hint' = 'tasting.event_over_hint',
  'tasting.tickets_soon' = 'tasting.tickets_soon',
  'tasting.tickets_soon_hint' = 'tasting.tickets_soon_hint',
  'tasting.overview_subtitle' = 'tasting.overview_subtitle',
  'tasting.overview_meta_title' = 'tasting.overview_meta_title',
  'tasting.overview_meta_description' = 'tasting.overview_meta_description',
  'tasting.filter_upcoming' = 'tasting.filter_upcoming',
  'tasting.filter_past' = 'tasting.filter_past',
  'tasting.load_more' = 'tasting.load_more',
  'tasting.none_found' = 'tasting.none_found',
  'tasting.spots' = 'tasting.spots',
  'tasting.agenda' = 'tasting.agenda',
  'tasting.lineup' = 'tasting.lineup',
  'tasting.lineup_intro' = 'tasting.lineup_intro',
  'tasting.upcoming' = 'tasting.upcoming',
  'tasting.all_tastings' = 'tasting.all_tastings',
  'tasting.location_date_time' = 'tasting.location_date_time',
  'tasting.faqs.faq1_q' = 'tasting.faqs.faq1_q',
  'tasting.faqs.faq1_a' = 'tasting.faqs.faq1_a',
  'tasting.faqs.faq2_q' = 'tasting.faqs.faq2_q',
  'tasting.faqs.faq2_a' = 'tasting.faqs.faq2_a',
  'tasting.faqs.faq3_q' = 'tasting.faqs.faq3_q',
  'tasting.faqs.faq3_a' = 'tasting.faqs.faq3_a',
  'tasting.faqs.faq4_q' = 'tasting.faqs.faq4_q',
  'tasting.faqs.faq4_a' = 'tasting.faqs.faq4_a',
  'tasting.faqs.faq5_q' = 'tasting.faqs.faq5_q',
  'tasting.faqs.faq5_a' = 'tasting.faqs.faq5_a',
  'tasting.faqs.faq6_q' = 'tasting.faqs.faq6_q',
  'tasting.faqs.faq6_a' = 'tasting.faqs.faq6_a',
  'tasting.faqs.faq7_q' = 'tasting.faqs.faq7_q',
  'tasting.faqs.faq7_a' = 'tasting.faqs.faq7_a',
  'tasting.faqs.faq8_q' = 'tasting.faqs.faq8_q',
  'tasting.faqs.faq8_a' = 'tasting.faqs.faq8_a',
  'checkout.no_longer_available' = 'checkout.no_longer_available',
  'checkout.price_changed' = 'checkout.price_changed',
  'checkout.pickup_not_available' = 'checkout.pickup_not_available',
  'checkout.address_required' = 'checkout.address_required',
  'checkout.payment_received' = 'checkout.payment_received',
}

export { SkuEnum };
